import { useCallback } from "react"
import { Extension } from "@codemirror/state"
import { useTypescript } from "./use-typescript"
import { javascript } from "@codemirror/lang-javascript"

type Props = {
  id: string
}

export function useLanguageExtensions(props: Props) {
  const { id } = props

  const { createWorker: createTsWorker } = useTypescript({
    id,
  })

  const getLanguageExtensions = useCallback(async (initialContent = ""): Promise<Extension[]> => {
    const langExtensions: Extension[] = []
    
    langExtensions.push(
      javascript({
        jsx: true,
        typescript: true,
      }),
    )

    // 异步加载 TypeScript 扩展
    const tsExtension = await createTsWorker(initialContent)
    langExtensions.push(tsExtension)

    return langExtensions
  }, [createTsWorker])

  return {
    getLanguageExtensions,
  }
}
